export default __webpack_public_path__ + "static/media/applepay.644e0946.svg";